<p-menu #profileMenu [model]="menuItems()" [popup]="true">
  <ng-template #start>
    <span class="flex items-center gap-5 px-4 py-4 border-b border-gray-300">
      <span class="pi pi-user text-primary font-bold"></span>
      <span>
        <strong>{{ $user()?.fullName }}</strong>
        <br />
        {{ $user()?.emailAddress }}
      </span>
    </span>
    <span class="flex items-center gap-5 px-4 py-4 border-b border-gray-300">
      <p-selectbutton
        [ngModel]="$darkTheme()"
        (ngModelChange)="toggleDarkMode()"
        [options]="themeOptions"
        optionLabel="name"
        optionValue="value"
        [allowEmpty]="false"
      ></p-selectbutton>
    </span>
  </ng-template>
  <ng-template #item let-item>
    <!-- Language selector -->
    @if (item.id === "language-selector") {
      <!-- Not allowing passing styles here, because it is a custom component -->
      <button
        pRipple
        class="flex flex-row items-center p-menu-item-link cursor-pointer w-full"
        (click)="toggleLanguageSelector($event)"
      >
        <span [class]="item.icon"></span>
        <span class="ml-2">{{ item.label }}</span>
        <span
          [class]="'ml-auto text-sm ' + (languageSelectorExpanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right')"
        ></span>
      </button>
      @if (languageSelectorExpanded) {
        <div class="flex flex-col px-4 py-2 bg-surface-hover">
          @for (language of availableLanguages; track language.code; let last = $last) {
            <button
              pRipple
              class="flex flex-row items-center px-2 py-2 gap-2 cursor-pointer hover:bg-gray-200 dark:hover:bg-gray-800 rounded transition-colors"
              (click)="selectLanguage(language.code)"
            >
              <img [src]="'flags/' + language.code + '.svg'" [attr.alt]="language.name" class="w-4 h-4" />
              <span>{{ language.name }}</span>
            </button>
            @if (!last) {
              <div class="h-px bg-gray-200 dark:bg-gray-200/20"></div>
            }
          }
        </div>
      }
    } @else if (item.id === "notification-frequency-selector") {
      <!-- Email notification frequency selector -->
      <button
        pRipple
        class="flex flex-row items-center p-menu-item-link cursor-pointer w-full"
        [attr.aria-expanded]="emailNotificationSelectorExpanded"
        (click)="toggleEmailNotificationSelector($event)"
      >
        <span [class]="item.icon"></span>
        <span class="ml-2">{{ item.label }}</span>
        <span
          [class]="
            'ml-auto text-sm ' + (emailNotificationSelectorExpanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right')
          "
        ></span>
      </button>
      @if (emailNotificationSelectorExpanded) {
        <div class="flex flex-col px-4 py-2 bg-surface-hover">
          @for (option of emailNotificationOptions; track option.value; let last = $last) {
            <button
              pRipple
              class="flex flex-row items-center px-2 py-2 gap-2 cursor-pointer hover:bg-gray-200 dark:hover:bg-gray-800 rounded transition-colors w-full"
              [class.font-semibold]="option.value === $emailNotificationFrequency()"
              [attr.aria-pressed]="option.value === $emailNotificationFrequency()"
              (click)="selectEmailNotificationFrequency(option.value, $event)"
            >
              <span>{{ option.label }}</span>
              @if (option.value === $emailNotificationFrequency()) {
                <span class="pi pi-check ml-auto text-sm text-primary"></span>
              }
            </button>
            @if (!last) {
              <div class="h-px bg-gray-200 dark:bg-gray-200/20"></div>
            }
          }
        </div>
      }
    } @else {
      <!-- Other menu items -->
      <a pRipple class="flex items-center p-menu-item-link" [ngStyle]="item.style" [ngClass]="item.styleClass">
        <span [class]="item.icon"></span>
        <span class="ml-2">{{ item.label }}</span>
      </a>
    }
  </ng-template>
</p-menu>

<p-button [text]="true" (click)="profileMenu.toggle($event)">
  <i class="pi pi-user" style="font-size: 1.2rem"></i>
</p-button>
